import EnterApplication from "go-security/components/EnterApplication";

const EnterApplicationPage = (): JSX.Element => {
	return <EnterApplication />;
};
export default EnterApplicationPage;
